module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\n// image(s) given\nif (!utils.isEmpty(model.galleryImages)){\nvar images = \"\";\nvar titles = \"\";\nvar firstImg = true;\n// get list of detected rendered images\nvar imageList = helpers.detectRenderedImages(model.galleryImages, model._galleryImages);\n// a list of images results in an carousel\nimageList.forEach(function(image){\nvar activeClass = (firstImg ? ' class=\"active\"' : '');\nimages += '<div' + activeClass + ' style=\"background-image:url(' + image.rendered.url + ')\" title=\"' + image.rendered.title +'\" alt=\"' + image.rendered.alt +'\"></div>';\ntitles += (firstImg ? '' : ' / ') + '<a>' + image.title + '</a>';\nfirstImg = false;\n})\n}\n%>\n<div class=\"images\">\n<%- images %>\n</div>\n<div class=\"titles\">\n<%- titles %>\n</div>\n</div>"
  , __filename = "components/templates/carousel/carousel.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
// image(s) given
if (!utils.isEmpty(model.galleryImages)){
var images = "";
var titles = "";
var firstImg = true;
// get list of detected rendered images
var imageList = helpers.detectRenderedImages(model.galleryImages, model._galleryImages);
// a list of images results in an carousel
imageList.forEach(function(image){
var activeClass = (firstImg ? ' class="active"' : '');
images += '<div' + activeClass + ' style="background-image:url(' + image.rendered.url + ')" title="' + image.rendered.title +'" alt="' + image.rendered.alt +'"></div>';
titles += (firstImg ? '' : ' / ') + '<a>' + image.title + '</a>';
firstImg = false;
})
}

    ; __line = 18
    ; __append("\n<div class=\"images\">\n")
    ; __line = 20
    ; __append( images )
    ; __append("\n</div>\n<div class=\"titles\">\n")
    ; __line = 23
    ; __append( titles )
    ; __append("\n</div>\n</div>")
    ; __line = 25
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/carousel/carousel.ejs

}